import { useQuery } from '@tanstack/react-query';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import { getInvoices } from '../services/cartService';
import { FEATURE_FLAG_KEYS } from '../../../../../config/growthbook';

const INVOICES_QUERY_KEY = '/api/resilience/v1/invoices';

export const useInvoices = () => {
  const crsEnableSelfServe = useFeatureIsOn(
    FEATURE_FLAG_KEYS.CRS_ENABLE_SELF_SERVE
  );

  return useQuery({
    queryKey: [INVOICES_QUERY_KEY],
    queryFn: () => getInvoices().then((res) => res.data ?? []),
    refetchOnWindowFocus: true,
    enabled: crsEnableSelfServe,
  });
};

useInvoices.queryKey = INVOICES_QUERY_KEY;
